import { useState, useEffect, useCallback } from 'react';
import { getWMSBroadcastUtil } from '../utils/wmsBroadcastMassiveDispatchUtil';

export const useWMSLockMassiveDispatch = () => {
  const [isLocked, setIsLocked] = useState(() => {
    return getWMSBroadcastUtil().getIsLocked();
  });

  useEffect(() => {
    const util = getWMSBroadcastUtil();
    const unsubscribe = util.subscribe(setIsLocked);

    return () => {
      unsubscribe();
    };
  }, []);

  const lock = useCallback(() => {
    getWMSBroadcastUtil().lock();
  }, []);

  const unlock = useCallback(() => {
    getWMSBroadcastUtil().unlock();
  }, []);

  return {
    isLocked,
    lock,
    unlock
  };
};